export default __webpack_public_path__ + "static/tad_vip_1-fabd9bef132a7d9fbd97c447ed65f63e.jpeg";